export const articles = [
  {
    id: "dingliu-huanjiao",
    title: "顶流新剧开拍前后三次换角，到底卡在哪一步",
    summary:
      "一部从立项就顶着高期待的古装大剧，开机前却接连调整阵容。表面是档期不合，往深了看，真正卡住选角的是资源、番位与播出排期这三件事。",
    topicId: "dingliu",
    topicName: "顶流风波",
    tags: ["选角", "档期", "资源"],
    date: "2026-09-08",
    author: "瓜田观察员",
    readTime: "6 分钟",
    views: "42.6万",
    image:
      "https://readdy.ai/api/search-image?query=Empty%20film%20set%20with%20lighting%20rigs%20and%20a%20director%20chair%20under%20a%20single%20warm%20spotlight%2C%20cinematic%20editorial%20photography%2C%20coral%20and%20amber%20tones%2C%20no%20people%2C%20high%20detail%20texture&width=800&height=600&seq=gt-art-dingliu-huanjiao&orientation=landscape",
    imageAlt: "空置的古装剧拍摄现场灯光与导演椅，暖调戏剧光",
    content: [
      {
        type: "p",
        text: "这部剧从立项起就被贴上“年度重点项目”的标签，造型、美术、剧本围读的通稿一波接一波，唯独主演阵容始终悬着。开机前一个月里，网传的男女主组合至少换了三轮，每次都有“知情人”出来确认。",
      },
      {
        type: "h2",
        text: "先说最常被拿出来说的“档期不合”",
      },
      {
        type: "p",
        text: "档期确实是绕不开的一环。S 级项目往往要提前大半年锁人，而头部艺人的档期表基本排到一年以后，综艺、代言、巡演、补拍挤在一起，只要有任何一个环节顺延，整个进组时间就得重排。所谓“档期不合”，很多时候不是不想演，而是几方的时间表根本凑不到一起。",
      },
      {
        type: "h2",
        text: "比档期更难谈的是番位",
      },
      {
        type: "p",
        text: "番位看似只是海报上的先后，实际上关系到后续的宣传资源、商务曝光的优先级，甚至影响到剧组内部的资源分配。两位都在上升期的演员同框，谁在前谁在后，往往要拉锯到合同细则里的小字部分。这类谈判拖得越久，越容易出现临时换人的情况。",
      },
      {
        type: "h2",
        text: "最后压垮谈判的，往往是排播",
      },
      {
        type: "p",
        text: "平台排播计划一变，项目的整个节奏就要跟着调整。有的项目为了卡住某个档期，宁可等演员、宁可延后开机；有的则必须在规定时间内开拍，于是只能换一个档期更宽松的演员顶上。理解了这一层，再看这次的三次换角，其实每一步都有它的现实逻辑。",
      },
      {
        type: "p",
        text: "对吃瓜的人来说，比追“最终阵容”更有意思的，是看清这类项目背后的博弈方式。阵容官宣那天，往往只是谈判结束的公告，而不是故事的开头。",
      },
    ],
  },
  {
    id: "juzu-yeban-huanren",
    title: "某古装剧组深夜换人内幕：一次关于番位的拉锯",
    summary:
      "凌晨收工后的一则剧组通知，让一位配角临时离组。看似是拍摄进度问题，实则牵出了番位、戏份与经纪团队之间长达数周的博弈。",
    topicId: "juzu",
    topicName: "剧组秘闻",
    tags: ["剧组", "番位", "戏份"],
    date: "2026-09-06",
    author: "剧组小喇叭",
    readTime: "5 分钟",
    views: "31.2万",
    image:
      "https://readdy.ai/api/search-image?query=Dark%20empty%20film%20studio%20at%20night%20with%20a%20single%20hanging%20work%20light%20and%20cables%20on%20the%20floor%2C%20moody%20cinematic%20editorial%20photography%2C%20deep%20coral%20and%20amber%20tones%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=gt-art-juzu-huanren&orientation=landscape",
    imageAlt: "深夜收工的剧组摄影棚，悬挂工作灯与地面线缆",
    content: [
      {
        type: "p",
        text: "事情发生在一次大夜戏收工之后。剧组群里的通知很短：因拍摄计划调整，某配角的部分戏份将另行安排。消息传到网上，很快被解读成“演员被踢出组”。",
      },
      {
        type: "h2",
        text: "戏份调整在剧组里其实很常见",
      },
      {
        type: "p",
        text: "前期拍摄和最终成片从来不是一回事。剧本会在拍摄过程中反复修改，有的支线被压缩，有的角色被合并，演员的进出组因此成为一个动态过程。真正值得注意的是：这次调整为什么会被拿出来反复讨论。",
      },
      {
        type: "h2",
        text: "关键在于“番位”两个字",
      },
      {
        type: "p",
        text: "番位并不是纯粹的虚荣心。它直接影响宣传期的物料排布、路演安排和后续的商务报价。当两位演员的团队都认为自己的艺人该有更靠前的位置时，谈判就会从海报排序延伸到戏份长度。戏份一旦被调整，外界自然会把两件事联系起来。",
      },
      {
        type: "h2",
        text: "最后按下暂停键的，往往是制作方",
      },
      {
        type: "p",
        text: "制作方最关心的是进度和成片质量。当协调成本高到影响拍摄时，换一个配合度更高的演员，是最省事的解法。这不是谁对谁错，而是一次现实意义上的取舍。",
      },
      {
        type: "p",
        text: "所以下次看到“临时换人”的消息，不妨先想想：剧组的时间表、演员的档期、团队的诉求，这三者里到底是哪一环先松动的。",
      },
    ],
  },
  {
    id: "zongyi-jianji-taoben",
    title: "综艺剪辑里的“隐藏剧本”：名场面不全是巧合",
    summary:
      "一档热播综艺里的名场面被反复二创，但现场观众的说法和成片并不完全一致。剪辑如何制造冲突、放大情绪，这篇文章带你拆开看。",
    topicId: "zongyi",
    topicName: "综艺内幕",
    tags: ["综艺", "剪辑", "名场面"],
    date: "2026-09-05",
    author: "综艺复盘局",
    readTime: "7 分钟",
    views: "28.4万",
    image:
      "https://readdy.ai/api/search-image?query=Video%20editing%20timeline%20on%20dual%20monitors%20in%20a%20dim%20studio%20with%20warm%20desk%20lamp%20glow%2C%20moody%20editorial%20photography%2C%20coral%20and%20amber%20tones%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=gt-art-zongyi-jianji&orientation=landscape",
    imageAlt: "昏暗剪辑室中的双屏剪辑时间线，暖色台灯光",
    content: [
      {
        type: "p",
        text: "一档综艺能不能出圈，很多时候取决于有没有一个可以反复传播的名场面。而名场面是怎么被“做”出来的，恰恰是剪辑室里最有意思的部分。",
      },
      {
        type: "h2",
        text: "素材量决定了剪辑的话语权",
      },
      {
        type: "p",
        text: "一集节目录制的原始素材动辄几十上百小时，最终播出的只有一个多小时。也就是说，观众看到的一切，都经过了强烈的筛选。同一段对话，放前面还是放后面、留几秒的沉默、加不加反应镜头，观感可能完全不同。",
      },
      {
        type: "h2",
        text: "音乐和字幕，是情绪的放大器",
      },
      {
        type: "p",
        text: "背景音乐一变，观众对同一句话的理解就会偏移；花字和特效字幕一句调侃，就能把中性的画面导向“尴尬”或“甜蜜”。所以现场观众说“当时气氛其实挺和谐”，和成片呈现的紧张感并不矛盾——那是两种不同的讲述方式。",
      },
      {
        type: "h2",
        text: "看懂剪辑，不代表失去乐趣",
      },
      {
        type: "p",
        text: "拆解剪辑逻辑不是为了扫兴，而是让吃瓜更有层次。知道了镜头背后的选择，你依然可以享受名场面，只是多了一层判断力：哪些是真实反应，哪些是被放大的叙事。",
      },
      {
        type: "p",
        text: "下一个爆款名场面出现时，不妨留意一下镜头的切换节奏和配乐的进入点，你会看到很多有趣的设计。",
      },
    ],
  },
  {
    id: "daiyan-san-jia-zheng",
    title: "同一个代言三家争，品牌为什么最后选了“数据第二”的那位",
    summary:
      "一场看似只看数据的代言争夺，最终结果却出人意料。品牌方真正在意的，从来不只是粉丝刷出来的那串数字。",
    topicId: "daiyan",
    topicName: "代言与资源",
    tags: ["代言", "商务", "数据"],
    date: "2026-09-03",
    author: "商务观察席",
    readTime: "5 分钟",
    views: "19.8万",
    image:
      "https://readdy.ai/api/search-image?query=Luxury%20perfume%20bottle%20and%20skincare%20products%20on%20a%20marble%20podium%20lit%20by%20warm%20spotlight%2C%20elegant%20editorial%20still%20life%2C%20coral%20and%20cream%20tones%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=gt-art-daiyan-zheng&orientation=landscape",
    imageAlt: "大理石展台上的香水与护肤产品，暖色聚光打亮",
    content: [
      {
        type: "p",
        text: "一个头部美妆品牌的年度代言，三位艺人同时接触了大半年。从粉丝体量看，其中一位的数据遥遥领先；从讨论热度看，另两位也各有优势。最后签约的，却是数据排在第二的那位。",
      },
      {
        type: "h2",
        text: "数据只是入场券，不是判决书",
      },
      {
        type: "p",
        text: "品牌评估艺人，会同时看几套指标：粉丝画像与产品受众的重合度、带货转化的真实性、以及舆情风险。前者的数字再漂亮，如果受众和产品主力消费人群对不上，商业价值就打了折扣。",
      },
      {
        type: "h2",
        text: "“安全”在商务里是硬通货",
      },
      {
        type: "p",
        text: "越是客单价高、品牌形象稳定的品类，越怕艺人翻车带来的连带损失。有没有负面讨论、过往合作是否有纠纷、团队沟通是否顺畅，都会被反复评估。一个合作顺利、口碑平稳的艺人，往往比一个数据顶尖但舆情波动大的艺人更受欢迎。",
      },
      {
        type: "h2",
        text: "长期合作比一次性曝光更值钱",
      },
      {
        type: "p",
        text: "很多品牌现在更看重能否签下长期、多品线的合作。这就要求艺人的形象足够稳定、可延展。数据型选手适合短期冲量，而品牌代言人往往要的是能陪伴品牌走几年的面孔。",
      },
      {
        type: "p",
        text: "所以当结果和“数据排名”不一致时，别急着说品牌看走眼。商务决策是一道综合题，粉丝能看到的那一份，往往只是其中一页。",
      },
    ],
  },
  {
    id: "sixia-san-ci-tongkuang",
    title: "从三次同框到晚宴邻座，这条关系线藏了半年",
    summary:
      "两位艺人被拍到的同框次数不多，但每一次的时间点都很巧。把三次同框的时间轴排开，一条若隐若现的关系线就浮现出来了。",
    topicId: "sixia",
    topicName: "私下交集",
    tags: ["同框", "关系线", "时间轴"],
    date: "2026-09-01",
    author: "瓜田线索组",
    readTime: "4 分钟",
    views: "36.5万",
    image:
      "https://readdy.ai/api/search-image?query=Two%20coffee%20cups%20and%20a%20small%20notebook%20on%20a%20cafe%20table%20beside%20a%20rain%20streaked%20window%2C%20warm%20intimate%20lighting%2C%20cinematic%20editorial%20photography%2C%20amber%20and%20cream%20tones%2C%20no%20people&width=800&height=600&seq=gt-art-sixia-tongkuang&orientation=landscape",
    imageAlt: "雨天咖啡馆窗边的两杯咖啡与便签本，暖色氛围",
    content: [
      {
        type: "p",
        text: "要判断两个人关系如何，单看一次同框没有意义。有意思的是把时间轴拉长，看他们出现在同一场合的频率和时机。",
      },
      {
        type: "h2",
        text: "第一次：活动后台的短暂交集",
      },
      {
        type: "p",
        text: "第一次被拍到是在一场品牌活动的后台，两人只是简单打招呼。这类场合交集众多，本不值得过度解读。但值得注意的是，此后几个月里，他们在多个公开活动的行程开始出现重叠。",
      },
      {
        type: "h2",
        text: "第二次：朋友局的偶遇",
      },
      {
        type: "p",
        text: "第二次是共同好友的生日聚会。这种场合通常不会对外公开，能被拍到本身就是个信号——说明两人在同一个社交圈子里已经有了一定的交集基础。",
      },
      {
        type: "h2",
        text: "第三次：晚宴邻座的座位表",
      },
      {
        type: "p",
        text: "第三次是行业晚宴。座位表看似随机，但重要场合的座位安排往往经过仔细沟通。邻座意味着至少有一方团队并不排斥这种同框。把这三次放在一起看，关系线的轮廓就清楚了。",
      },
      {
        type: "p",
        text: "当然，关系升温不等于外界想象的那种剧情。把同框当作线索而不是结论，才是吃瓜最舒服的姿势。",
      },
    ],
  },
  {
    id: "hangye-resou-lujing",
    title: "热搜不是凭空来的：一条爆料如何被推上第一位",
    summary:
      "从一条匿名投稿到全网热搜，中间到底发生了什么？这篇文章拆解爆料的传播路径，帮你看懂热搜的形成机制。",
    topicId: "hangye",
    topicName: "行业观察",
    tags: ["热搜", "传播", "机制"],
    date: "2026-08-30",
    author: "行业显微镜",
    readTime: "8 分钟",
    views: "52.1万",
    image:
      "https://readdy.ai/api/search-image?query=Stack%20of%20entertainment%20newspapers%20and%20magazines%20on%20a%20wooden%20desk%20under%20a%20warm%20desk%20lamp%2C%20moody%20editorial%20still%20life%2C%20coral%20and%20amber%20tones%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=gt-art-hangye-resou&orientation=landscape",
    imageAlt: "暖色台灯下木桌上堆叠的娱乐报刊杂志",
    content: [
      {
        type: "p",
        text: "一条匿名爆料从发布到登上热搜第一位，往往只需要几个小时。看起来很玄学，其实每一步都有迹可循。",
      },
      {
        type: "h2",
        text: "第一步：找到可以承接的账号",
      },
      {
        type: "p",
        text: "爆料很少从零开始扩散。投稿人会选择那些粉丝基数大、互动活跃的账号作为首发点，借助已有的关注度完成第一波曝光。这个阶段内容通常语焉不详，留足悬念。",
      },
      {
        type: "h2",
        text: "第二步：靠“猜人”制造二次传播",
      },
      {
        type: "p",
        text: "模糊的描述是最好的燃料。读者为了“对号入座”，会主动在评论区讨论、列举、反驳，这些互动本身就是继续放大热度的动力。当讨论量达到某个临界点，平台的自然推荐就会介入。",
      },
      {
        type: "h2",
        text: "第三步：多方回应或沉默，决定走向",
      },
      {
        type: "p",
        text: "当事人是否回应、回应的速度快慢、措辞是否得当，会显著影响舆论走向。快速、清晰的回应有机会让话题降温；含糊其辞或干脆沉默，则可能让讨论持续发酵。",
      },
      {
        type: "h2",
        text: "看懂机制，不代表要冷漠",
      },
      {
        type: "p",
        text: "了解热搜是怎么形成的，不是为了否定所有爆料，而是提醒自己：热度高不等于事实确凿。在信息还没沉淀之前，保持一点耐心，往往比第一时间站队更聪明。",
      },
      {
        type: "p",
        text: "这也是我们做“行业观察”这个栏目最想传达的态度——把瓜吃出方法论。",
      },
    ],
  },
  {
    id: "hangye-shuju-koubei",
    title: "数据与口碑打架时，业内到底看哪张表",
    summary:
      "一边是漂亮的播放数据，一边是平平的口碑评分。当两者矛盾时，从业者会翻开哪一份报告？答案比想象中务实。",
    topicId: "hangye",
    topicName: "行业观察",
    tags: ["数据", "口碑", "评估"],
    date: "2026-08-27",
    author: "行业显微镜",
    readTime: "6 分钟",
    views: "17.3万",
    image:
      "https://readdy.ai/api/search-image?query=Analytics%20charts%20and%20printed%20reports%20spread%20on%20a%20dark%20wooden%20desk%20with%20warm%20lamp%20light%2C%20editorial%20still%20life%2C%20coral%20and%20amber%20tones%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=gt-art-hangye-shuju&orientation=landscape",
    imageAlt: "深色木桌上摊开的数据图表与打印报告，暖色灯光",
    content: [
      {
        type: "p",
        text: "一部作品播出后，经常出现“数据很亮眼、口碑却一般”的场面。围观的人争论不休，而真正做决策的从业者，看的其实是另一套东西。",
      },
      {
        type: "h2",
        text: "先看的是“有效播放”而不是总播放",
      },
      {
        type: "p",
        text: "总播放量容易被开头几集的高热度拉高，真正有参考价值的是完播率、续看率和用户停留时长。一部剧如果前三集拉满、后面大量弃剧，从业者一眼就能看出问题。",
      },
      {
        type: "h2",
        text: "再看的是受众结构",
      },
      {
        type: "p",
        text: "广告主关心的是观众画像：年龄、地域、消费能力。一部数据漂亮但受众高度集中在单一圈层的作品，商业价值未必高于一部数据中等、但受众更均衡的作品。",
      },
      {
        type: "h2",
        text: "口碑在长线里会说话",
      },
      {
        type: "p",
        text: "短期看数据，长期看口碑。口碑好的作品有更长的播放生命周期和更强的长尾收益，也更容易带动艺人后续的资源。所以从业者不会只看一张表，而是把几张表叠在一起看。",
      },
      {
        type: "p",
        text: "下次看到数据与口碑打架，先别急着选边。问问自己：这份数据统计的是哪一个口径，覆盖的又是哪一群人。",
      },
    ],
  },
  {
    id: "dingliu-yingyuan-shuju",
    title: "应援数据被质疑注水之后，粉丝和路人各说了什么",
    summary:
      "一次应援活动因为数据异常被推上风口浪尖。粉丝强调组织力，路人质疑真实性，这场争论背后其实是两套评价体系的碰撞。",
    topicId: "dingliu",
    topicName: "顶流风波",
    tags: ["应援", "数据", "粉丝"],
    date: "2026-08-24",
    author: "瓜田观察员",
    readTime: "5 分钟",
    views: "24.7万",
    image:
      "https://readdy.ai/api/search-image?query=Glowing%20smartphone%20screens%20stacked%20in%20a%20dark%20room%20casting%20warm%20red%20light%2C%20moody%20abstract%20editorial%20photography%2C%20coral%20and%20amber%20tones%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=gt-art-dingliu-yingyuan&orientation=landscape",
    imageAlt: "暗室中堆叠发光的手机屏幕，透出暖红色光",
    content: [
      {
        type: "p",
        text: "一次线下应援活动的相关数据在短时间内暴涨，很快有网友指出曲线“不太自然”。围绕这组数字，双方展开了一轮拉锯。",
      },
      {
        type: "h2",
        text: "粉丝的说法：组织力也是一种能力",
      },
      {
        type: "p",
        text: "支持者的核心观点是：应援本身就是高度组织化的行为，短时间内集中发力是常态。他们强调后援会的分工、打投的流程，认为用“异常”来概括并不公平。",
      },
      {
        type: "h2",
        text: "路人的疑问：透明度在哪",
      },
      {
        type: "p",
        text: "质疑者关心的则是数据能不能被验证。当增长缺乏可解释的来源时，外界的怀疑几乎是必然的。这不是针对某一方，而是对“看不懂的数字”的本能反应。",
      },
      {
        type: "h2",
        text: "争论的本质，是两套评价体系",
      },
      {
        type: "p",
        text: "粉丝看重的是“我们做到了多少”；路人看重的是“这件事是不是真的、有没有意义”。两套体系用的尺子不同，自然很难说服对方。理解了这一点，争论的热度也就能看得更明白。",
      },
      {
        type: "p",
        text: "对看客而言，最值得保留的是一点耐心：等数据沉淀、等更多信息出来，再下判断也不迟。",
      },
    ],
  },
  {
    id: "juzu-shaqing-fanwai",
    title: "杀青番外：那些没被收进正片的剧组日常",
    summary:
      "每部戏杀青后，总有一些不会出现在成片里的日常。盒饭赌约、群演的即兴发挥、导演的口头禅，才是剧组最真实的底色。",
    topicId: "juzu",
    topicName: "剧组秘闻",
    tags: ["杀青", "花絮", "日常"],
    date: "2026-08-21",
    author: "剧组小喇叭",
    readTime: "4 分钟",
    views: "15.9万",
    image:
      "https://readdy.ai/api/search-image?query=Backstage%20makeup%20mirror%20surrounded%20by%20warm%20bulbs%20with%20small%20props%20on%20the%20table%2C%20cinematic%20editorial%20still%20life%2C%20coral%20and%20cream%20tones%2C%20no%20people%2C%20high%20detail&width=800&height=600&seq=gt-art-juzu-shaqing&orientation=landscape",
    imageAlt: "剧组化妆间环绕暖色灯泡的化妆镜与桌上小道具",
    content: [
      {
        type: "p",
        text: "一部戏杀青，观众看到的是一张张定妆照和杀青特辑，而剧组自己记得的，往往是些琐碎的日常。",
      },
      {
        type: "h2",
        text: "关于盒饭的那些约定",
      },
      {
        type: "p",
        text: "拍摄周期一长，剧组的快乐就变得很朴素。有人用盒饭打赌今天能不能一条过，有人把加餐当成全组的仪式感。这些和剧情无关的片段，恰恰支撑起了一个团队半年的情绪。",
      },
      {
        type: "h2",
        text: "群演偶尔会贡献意外惊喜",
      },
      {
        type: "p",
        text: "很多出圈的画面，其实来自群演的临场发挥。导演有时候会保留这些“不完美”的瞬间，因为真实感往往藏在计划之外。",
      },
      {
        type: "h2",
        text: "口头禅是剧组的暗号",
      },
      {
        type: "p",
        text: "导演的某句口头禅、场记的习惯动作，最后都会变成全组共享的梗。杀青那天，这些梗会被反复提起，成为这半年最温暖的注脚。",
      },
      {
        type: "p",
        text: "关注主角固然有趣，但了解一个剧组如何运转，会让你看剧时多出一份会心的理解。",
      },
    ],
  },
];